
import {INVITAIONS_REQUEST, INVITAIONS_SUCCESS,INVITAIONS_FAIL} from "../constants/AuthConstant";

const axios = require("axios");
export const InvitationsAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: INVITAIONS_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_user_requested_profile_list?aadhaarCardNumber=${data?.aadhaar}&pageNumber=${data.pageNumber}&pageSize=10`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(InvitationsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: INVITAIONS_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const InvitationsPre = (data) => {
    return {
      type: INVITAIONS_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  